import { useRef, useEffect } from 'react';

export function PageTransition({ viewKey, children }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      ref.current.style.opacity = '0';
      ref.current.style.transform = 'translateY(8px)';
      requestAnimationFrame(() => {
        if (ref.current) {
          ref.current.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
          ref.current.style.opacity = '1';
          ref.current.style.transform = 'translateY(0)';
        }
      });
    }
  }, [viewKey]);

  return <div ref={ref}>{children}</div>;
}
